import { ASSETS } from "./assets-data";

const QuickCallData = {
    en: {
        title: 'Call Tropical Marine',
        subtitle: "Speak with our team about your dock, boat lift, or waterfront project — we'll get back to you same day.",
        paragraph: 'Expert marine construction advice for Cape Coral and all of Southwest Florida.',
        btnText: 'Call Us Now',
        media: ASSETS.LANDINGPAGEVIDEOTROPICAL,
    },

    he: {
        title: 'Call Tropical Marine',
        subtitle: "Speak with our team about your dock, boat lift, or waterfront project — we'll get back to you same day.",
        paragraph: 'Expert marine construction advice for Cape Coral and all of Southwest Florida.',
        btnText: 'Call Us Now',
        media: "/placeholder.svg",
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getQuickCallData(language) {
    const lang = resolveLanguage(language);
    return QuickCallData[lang] || QuickCallData.en;
}

export default QuickCallData;
